import React from 'react'
import '../../home-style.scss'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom'
import FullscreenIcon from '@mui/icons-material/Fullscreen'
import dayjs from 'dayjs'
import useYieldgraphStyles from '../Yieldgraph/styles'
import { saveAs } from 'file-saver'

const YieldGraphFilter = ({
  isButtonSelected,
  handleButtonClick,
  setOpenTable,
  handleChooseDate,
  technicalToDate,
  technicalFromDate,
  handleOpen,
  openTable,
  mapInverterSeries,
  graphDuration,
  setTechnicalFromDate,
  setTechnicalToDate,
  setinverterviewbutton,
  selectedButtons,
  handleSelectYearWIthDate,
  chartRef,
  inverterviewbutton,
  handleGraphupdateOptions,
}) => {
  const classes = useYieldgraphStyles()

  // Remove the datepickerDisable state - always allow date selection
  const [userModifiedDates, setUserModifiedDates] = React.useState(false)

  const exportToCSV = (rows) => {
    const headings = ['Date', ...rows.map((item) => item.name)]
    const csvContent = [headings.join(',')]
    const allDates = new Set()
    rows.forEach((item) =>
      item.data.forEach((row) =>
        allDates.add(dayjs(row.x).format('YYYY/MM/DD'))
      )
    )
    allDates.forEach((date) => {
      const rowData = [date]
      rows.forEach((item) => {
        const dataForDate = item.data.find(
          (row) => dayjs(row.x).format('YYYY/MM/DD') === date
        )
        rowData.push(dataForDate ? dataForDate.y : 0)
      })
      csvContent.push(rowData.join(','))
    })
    const blob = new Blob([csvContent.join('\n')], {
      type: 'text/csv;charset=utf-8',
    })
    saveAs(blob, 'Portfolio_Yield.csv')
  }

  const handleselectButton = (ButtonType, isUserDateChange = false) => {
    // If user manually changed dates, don't override them unless it's a tab change
    if (userModifiedDates && !isUserDateChange) {
      setinverterviewbutton('custom')
      selectedButtons.map((Gtype) => {
        return handleSelectYearWIthDate(Gtype, 'custom', technicalFromDate)
      })
      return
    }

    switch (ButtonType) {
      case 'year':
        const previous1yData = dayjs(dayjs(new Date())).subtract(11, 'month')
        setTechnicalFromDate(previous1yData)
        setTechnicalToDate(dayjs(new Date()))
        setinverterviewbutton('year')
        selectedButtons.map((Gtype) => {
          return handleSelectYearWIthDate(Gtype, 'year', previous1yData)
        })
        break
      case '1m':
        const previous1Data = dayjs(new Date()).subtract(29, 'day')
        setTechnicalFromDate(previous1Data)
        setTechnicalToDate(dayjs(new Date()))
        setinverterviewbutton('1m')
        selectedButtons.map((Gtype) => {
          return handleSelectYearWIthDate(Gtype, '1m', previous1Data)
        })
        break
      case '3m':
        const previous3Data = dayjs(dayjs(new Date())).subtract(2, 'month')
        setTechnicalFromDate(previous3Data)
        setTechnicalToDate(dayjs(new Date()))
        setinverterviewbutton('3m')
        selectedButtons.map((Gtype) => {
          return handleSelectYearWIthDate(Gtype, '3m', previous3Data)
        })
        break
      case '6m':
        const previous6Data = dayjs(dayjs(new Date())).subtract(5, 'month')
        console.log(previous6Data, 'previous6Data')
        setTechnicalFromDate(previous6Data)
        setTechnicalToDate(dayjs(new Date()))
        setinverterviewbutton('6m')
        selectedButtons.map((Gtype) => {
          return handleSelectYearWIthDate(Gtype, '6m', previous6Data)
        })
        break
      case 'mtd':
        const firstDateOfMonth = dayjs(new Date()).startOf('month')
        setTechnicalFromDate(firstDateOfMonth)
        setTechnicalToDate(dayjs(new Date()))
        setinverterviewbutton('mtd')
        selectedButtons.map((Gtype) => {
          return handleSelectYearWIthDate(Gtype, 'mtd', new Date())
        })
        break
      case 'ytd':
        const firstDateOfYear = dayjs(new Date()).startOf('year')
        setTechnicalFromDate(firstDateOfYear)
        setTechnicalToDate(dayjs(new Date()))
        setinverterviewbutton('ytd')
        selectedButtons.map((Gtype) => {
          return handleSelectYearWIthDate(Gtype, 'ytd', new Date())
        })
        break
      case 'custom':
        setinverterviewbutton('custom')
        selectedButtons.map((Gtype) => {
          return handleSelectYearWIthDate(Gtype, 'custom', technicalFromDate)
        })
        break
      default:
        break
    }
  }

  const handlegraphSort = (type) => {
    // Reset user modification flag when clicking tabs (except custom)
    if (type !== 'custom') {
      setUserModifiedDates(false)
    }

    let tickAmount, rotateFormat, tooltipFormat, buttonType

    switch (type) {
      case 'year':
        tickAmount = 12
        rotateFormat = 'MMM/YY'
        tooltipFormat = 'MMMM/YYYY'
        buttonType = 'year'
        break
      case '1m':
        tickAmount = 15
        rotateFormat = 'DD/MM'
        tooltipFormat = 'DD/MMMM/YYYY'
        buttonType = '1m'
        break
      case '3m':
        tickAmount = 3
        rotateFormat = 'MMM/YY'
        tooltipFormat = 'MMMM/YYYY'
        buttonType = '3m'
        break
      case '6m':
        tickAmount = 6
        rotateFormat = 'MMM/YY'
        tooltipFormat = 'MMMM/YYYY'
        buttonType = '6m'
        break
      case 'ytd':
        tickAmount = 15
        rotateFormat = 'MMM/YY'
        tooltipFormat = 'MMMM/YYYY'
        buttonType = type
        break
      case 'mtd':
        tickAmount = 15
        rotateFormat = 'DD/MM'
        tooltipFormat = 'MMMM/YYYY'
        buttonType = type
        break
      case 'custom':
        tickAmount = 15
        rotateFormat = 'DD/MM'
        tooltipFormat = 'DD/MMMM/YYYY'
        buttonType = 'custom'
        break
      default:
        return
    }

    const newOptions = {
      xaxis: {
        tickAmount: tickAmount || 15,
        tickPlacement: 'on',
        labels: {
          rotateAlways: true,
          formatter: (value, timestamp, opts) => {
            return dayjs(value).format(rotateFormat)
          },
        },
      },
      tooltip: {
        enabled: true,
        x: {
          show: true,
          format: 'MMMM',
          formatter: (value, opts) => {
            return dayjs(
              opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex].x
            ).format(tooltipFormat)
          },
        },
      },
    }

    if (!openTable) {
      handleGraphupdateOptions(newOptions)
    }

    handleselectButton(buttonType)
  }

  // Enhanced date change handler
  const handleDateChange = (value, type) => {
    setUserModifiedDates(true)
    // Switch to custom mode when user manually changes dates
    if (inverterviewbutton !== 'custom') {
      setinverterviewbutton('custom')
    }
    
    // Call the original handler
    handleChooseDate(value, type)
    
    // Trigger data fetch with custom parameters
    selectedButtons.map((Gtype) => {
      const fromDate = type === 'from' ? value : technicalFromDate
      const toDate = type === 'to' ? value : technicalToDate
      return handleSelectYearWIthDate(Gtype, 'custom', fromDate, toDate)
    })
  }

  return (
    <div className={classes.root}>
      <div className="align_btw mb_10">
        <div>
          <div className="h1">Portfolio Yield</div>
          <div
            className="head_button"
            style={
              isButtonSelected(`GTI`)
                ? { backgroundColor: 'rgba(89, 104, 183, 0.25)' }
                : {}
            }
            onClick={() => handleButtonClick(`GTI`, '', 1)}
          >
            GTI
          </div>
          <div
            className="head_button"
            style={
              isButtonSelected(`Yield`)
                ? { backgroundColor: 'rgba(89, 104, 183, 0.25)' }
                : {}
            }
            onClick={() => handleButtonClick(`Yield`, '', 1)}
          >
            Specific Yield
          </div>
        </div>
        <div className={classes.root}>
          <div className="align_end">
            <div class="check_graph mr_8">
              <input
                id="Yieldgraph"
                type="checkbox"
                onClick={() => setOpenTable(!openTable)}
              />
              <label for="Yieldgraph"></label>
            </div>
            <div className="mr_8">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                  <div className={classes.datePickerStyle}>
                    <DatePicker
                      style={{ width: '120px !important' }}
                      label="From Date"
                      minDate={dayjs(new Date()).subtract(2, 'year')}
                      maxDate={technicalToDate || dayjs()}
                      className={classes.datePicker}
                      format="DD-MM-YYYY"
                      value={technicalFromDate}
                      onChange={(value) => handleDateChange(value, 'from')}
                      // Always enabled now
                      disabled={false}
                    />
                  </div>
                </DemoContainer>
              </LocalizationProvider>
            </div>
            <div className="mr_8">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                  <div className={classes.datePickerStyle}>
                    <DatePicker
                      style={{ width: '120px !important' }}
                      label="To Date"
                      minDate={technicalFromDate || dayjs(new Date()).subtract(2, 'year')}
                      maxDate={dayjs()}
                      className={classes.datePicker}
                      format="DD-MM-YYYY"
                      value={technicalToDate}
                      onChange={(value) => handleDateChange(value, 'to')}
                      // Always enabled now
                      disabled={false}
                    />
                  </div>
                </DemoContainer>
              </LocalizationProvider>
            </div>
            {openTable && (
              <div className="mr_8">
                <VerticalAlignBottomIcon
                  className="i_clr pointer"
                  onClick={() => exportToCSV(mapInverterSeries)}
                />
              </div>
            )}
            <div className="mt8">
              <FullscreenIcon className="i_clr pointer" onClick={handleOpen} />
            </div>
          </div>
        </div>
      </div>
      <div className="align_btw mb_10">
        <div className="h2">
          {/* Optional: Add indicator when using custom dates */}
          {userModifiedDates && inverterviewbutton !== 'custom' && (
            <small style={{ color: '#666', fontStyle: 'italic' }}>
              Custom date range applied
            </small>
          )}
        </div>
        <div>
          <div
            className={
              graphDuration === 'custom' || (userModifiedDates && inverterviewbutton !== graphDuration) 
                ? 'day_s_bottomline' 
                : 'day_s_b '
            }
            onClick={() => handlegraphSort('custom')}
          >
            CUST
          </div>
          <div
            className={
              graphDuration === 'ytd' && !userModifiedDates ? 'day_s_bottomline' : 'day_s_b '
            }
            onClick={() => handlegraphSort('ytd')}
          >
            YTD
          </div>
          <div
            className={
              graphDuration === 'mtd' && !userModifiedDates ? 'day_s_bottomline' : 'day_s_b '
            }
            onClick={() => handlegraphSort('mtd')}
          >
            MTD
          </div>
          <div
            className={
              graphDuration === 'year' && !userModifiedDates ? 'day_s_bottomline' : 'day_s_b '
            }
            onClick={() => handlegraphSort('year')}
          >
            1 Y
          </div>
          <div
            className={
              graphDuration === '6m' && !userModifiedDates ? 'day_s_bottomline' : 'day_s_b '
            }
            onClick={() => handlegraphSort('6m')}
          >
            6 M
          </div>
          <div
            className={
              graphDuration === '3m' && !userModifiedDates ? 'day_s_bottomline' : 'day_s_b '
            }
            onClick={() => handlegraphSort('3m')}
          >
            3 M
          </div>
          <div
            className={
              graphDuration === '1m' && !userModifiedDates ? 'day_s_bottomline' : 'day_s_b '
            }
            onClick={() => handlegraphSort('1m')}
          >
            1 M
          </div>
        </div>
      </div>
    </div>
  )
}

export default YieldGraphFilter
